// Handlers
import { ButtonHandlers } from '../../../components/button/handlers/button.handlers';
const ButtonHook = (props) => {
    const { onEventClick } = ButtonHandlers(props);
    return {
        onEventClick,
    };
};
export { ButtonHook };
//# sourceMappingURL=button.hook.js.map